@if (visible) {
<span [ngClass]="class">{{text}}</span>
}